import { render, staticRenderFns } from "./PanelCompetitionResult.vue?vue&type=template&id=c7cceb4c&scoped=true&"
import script from "./PanelCompetitionResult.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionResult.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionResult.vue?vue&type=style&index=0&id=c7cceb4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cceb4c",
  null
  
)

export default component.exports